import {ChallengeMode, EducationSessionPassedResult, UserInputAction, ChoiceUserInputAction} from "../../../schema";
import {WithoutTypename} from "../../../types";
import {DialogueHistoryEntry, PlayerReduxDispatch, PlayerReduxState} from "../types";

type PassedResult = WithoutTypename<EducationSessionPassedResult>;

export default function appendRpgUserTurnToDialogueHistory(
  result: PassedResult,
  inputAction: UserInputAction | ChoiceUserInputAction,
) {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    if (result.interrupt) {
      return;
    }
    const state = getState();
    if (state.challenge.mode !== ChallengeMode.RPG_MODE) {
      return;
    }

    if (inputAction.__typename === "UserInputAction") {
      const recognizedText = state.lastUserInputResult?.recognizedText ?? result.recognizedText ?? undefined;
      if (recognizedText == null || recognizedText === "") {
        return;
      }
      const entry: DialogueHistoryEntry = {
        action: inputAction,
        recognizedText,
      };
      dispatch({type: "appendDialogueHistory", payload: entry});
      return;
    }

    if (inputAction.__typename === "ChoiceUserInputAction") {
      const chosenBranchIds =
        state.chosenBranches.size > 0
          ? Array.from(state.chosenBranches)
          : result.branchId != null
            ? [result.branchId]
            : [];
      if (chosenBranchIds.length === 0) {
        return;
      }
      const recognizedText = state.lastUserInputResult?.recognizedText ?? result.recognizedText;
      const entry: DialogueHistoryEntry = {
        action: inputAction,
        chosenBranchIds,
        ...(recognizedText != null && recognizedText !== "" ? {recognizedText} : {}),
      };
      dispatch({type: "appendDialogueHistory", payload: entry});
    }
  };
}
